export default function () {
    function findItemIndexById(id: number, items: { id: number }[]): number {
        const finded_index = items.findIndex((item) => item.id === id)
        return finded_index
    }

    function findObjectByValue<T>(key: string, value: any, items: T[]): T | undefined {
        return items.find((item: any) => {
            if (key === 'name') {
                const item_value = item[key] as string
                return item_value.toUpperCase() === value.toUpperCase()
            }

            return item[key] === value
        })
    }

    function promisedDelay(delay = 2000) {
        return new Promise<void>((resolve) => {
            setTimeout(resolve, delay)
        })
    }

    return { findItemIndexById, findObjectByValue, promisedDelay }
}
